import { StoreSlice } from "../types";

export declare type IPlayCanvasGameRef = {
  [key: string]: any;
};

export declare interface IPlayCanvaSliceProps {
  characterSelected: number;
  isGamePlayedBack: boolean;
  playCanvGame1Ref: IPlayCanvasGameRef | null;
}

export declare interface IPlayCanvaSliceSetters {
  setCharacterSelected: (v: number) => void;
  setIsGamePlayedBack: (v: boolean) => void;
  setPlayCanvGame1Ref: (v: any) => void;
}

export declare type IPlayCanvaSlice = IPlayCanvaSliceProps & IPlayCanvaSliceSetters;

const createPlayCanvasSlice: StoreSlice<IPlayCanvaSliceProps, IPlayCanvaSliceSetters> = (
  set
) => ({
  characterSelected: 0,
  playCanvGame1Ref: null,
  isGamePlayedBack: false,
  setCharacterSelected: (v) =>
    set((state) => {
      state.characterSelected = v;
    }),
  setIsGamePlayedBack: (v) =>
    set((state) => {
      state.isGamePlayedBack = v;
    }),
  setPlayCanvGame1Ref: (v) =>
    set((state) => {
      state.playCanvGame1Ref = v;
    }),
});

export default createPlayCanvasSlice;
